<template>
  <span>
    <slot name="button" v-bind="{ onclick: toggle }">
      <b-button variant="primary" class="mr-1" size="xs" @click="toggle"
        ><i class="fas fa-edit"></i>&nbsp;Edit</b-button
      >
    </slot>

    <b-modal
      @show="onShow"
      @hidden="resetModal"
      ref="modal-container"
      v-model="modalShow"
      size="lg"
      :title="title"
      :static="true"
      :lazy="true"
      hide-footer
    >
      <form ref="form" @submit.stop.prevent="handleSubmit">
        <b-form-group label="_ID" label-for="id-input" v-if="!this.create">
          <b-form-input
            id="id-input"
            v-model="formValues.id"
            autocomplete="off"
            disabled
          />
        </b-form-group>

        <b-form-group label="Name" label-for="name-input">
          <b-form-input
            id="name-input"
            v-model="formValues.name"
            v-validate="{ required: true, min: 2 }"
            :state="validateState('name-input')"
            aria-describedby="name-input-live-feedback"
            data-vv-name="name-input"
            data-vv-as="Name"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="name-input-live-feedback">
            {{ veeErrors.first('name-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Order" label-for="order-input">
          <b-form-input
            id="order-input"
            type="number"
            v-model="formValues.order"
            v-validate="{ required: true, min_value: 0 }"
            :state="validateState('order-input')"
            aria-describedby="order-input-live-feedback"
            data-vv-name="order-input"
            data-vv-as="Order"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="order-input-live-feedback">
            {{ veeErrors.first('order-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Tables" label-for="tables-input">
          <multiselect
            id="tables-input"
            v-model="selectedTables"
            :options="tablesOptions"
            :custom-label="opt => opt.label"
            track-by="value"
            :multiple="true"
            :placeholder="$t('Select')"
            :select-label="$t('Press enter to select')"
            :selected-label="$t('Selected')"
            :loading="!this.$store.getters['tablesForSelect/loaded']"
            :disabled="!this.$store.getters['tablesForSelect/loaded']"
            :hide-selected="true"
          />
        </b-form-group>

        <b-form-group label="IP" label-for="ip-input">
          <!-- :state="validateState('ip-input')" -->
          <!-- v-validate="{ required: !this.formValues.proxy, ip: !this.formValues.proxy }" -->

          <b-form-input
            id="ip-input"
            v-model="formValues.ip"
            aria-describedby="ip-input-live-feedback"
            data-vv-name="ip-input"
            data-vv-as="IP"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="ip-input-live-feedback">
            {{ veeErrors.first('ip-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Port" label-for="port-input" type="number">
          <b-form-input
            id="port-input"
            type="number"
            v-model="formValues.port"
            v-validate="{ required: !!this.formValues.ip }"
            :state="validateState('port-input')"
            aria-describedby="port-input-live-feedback"
            data-vv-name="port-input"
            data-vv-as="Port"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="port-input-live-feedback">
            {{ veeErrors.first('port-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Timeout" label-for="timeout-input">
          <b-form-input
            id="timeout-input"
            type="number"
            v-model="formValues.timeout"
            v-validate="{ required: true }"
            :state="validateState('timeout-input')"
            aria-describedby="timeout-input-live-feedback"
            data-vv-name="timeout-input"
            data-vv-as="Timeout"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="timeout-input-live-feedback">
            {{ veeErrors.first('timeout-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Proxy" label-for="proxy-input">
          <b-form-input
            id="proxy-input"
            v-model="formValues.proxy"
            v-validate="{
              required: !this.formValues.ip,
              min_value: !this.formValues.ip ? 1 : false
            }"
            :state="validateState('proxy-input')"
            aria-describedby="proxy-input-live-feedback"
            data-vv-name="proxy-input"
            data-vv-as="Proxy"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="proxy-input-live-feedback">
            {{ veeErrors.first('proxy-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Proxy port" label-for="proxyPort-input">
          <b-form-input
            id="proxyPort-input"
            v-model="formValues.proxyPort"
            v-validate="{ required: !!this.formValues.proxy }"
            :state="validateState('proxyPort-input')"
            aria-describedby="proxyPort-input-live-feedback"
            data-vv-name="proxyPort-input"
            data-vv-as="Proxy port"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="proxyPort-input-live-feedback">
            {{ veeErrors.first('proxyPort-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Game type" label-for="gameType-input">
          <b-form-select
            id="gameType-input"
            v-model="formValues.gameType"
            v-validate="{ required: true }"
            :options="gameTypeOptions"
            :state="validateState('gameType-input')"
            aria-describedby="gameType-input-live-feedback"
            data-vv-name="gameType-input"
            data-vv-as="Game type"
            :disabled="!this.create"
          />
          <b-form-invalid-feedback id="gameType-input-live-feedback">
            {{ veeErrors.first('gameType-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
            id="active-mod-input"
            v-model="formValues.activeMod"
            @change="handleActiveMod"
          >
            Active Mod for Roulette
          </b-form-checkbox>
        </b-form-group>

        <b-form-group label="Player" label-for="player-input">
          <v-jsoneditor
            ref="player-editor"
            v-model="formValues.player"
            :options="{
              mode: 'code',
              enableSort: false,
              enableTransform: false
            }"
            :plus="false"
          />
          <b-form-input
            id="player-editor-error"
            v-model="playerEditorError"
            v-validate="{ is: '' }"
            :state="validateState('player-editor-error')"
            aria-describedby="player-editor-error-live-feedback"
            data-vv-name="player-editor-error"
            data-vv-as="Value"
            hidden
            autocomplete="off"
          />
          <b-form-invalid-feedback
            id="player-editor-error-live-feedback"
            v-if="veeErrors.first('player-editor-error')"
          >
            {{ playerEditorError }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="API Key" label-for="api-key">
          <b-form-input
            id="api-key-input"
            v-model="formValues.apiKey"
            v-validate="{ required: false }"
            :state="validateState('api-key-input')"
            aria-describedby="api-key-input-live-feedback"
            data-vv-name="api-key-input"
            data-vv-as="API Key"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="api-key-input-live-feedback">
            {{ veeErrors.first('api-key-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Croupier Interface" label-for="croupier-interface">
          <b-form-select
            id="croupier-interface"
            v-model="formValues.player.croupierInterface"
            :options="croupierInterfaceOptions"
            aria-describedby="currency-input-live-feedback"
            data-vv-name="croupier-interface"
            data-vv-as="Croupier Interface"
          />
        </b-form-group>

        <b-form-group label="Slave ID" label-for="slave-id">
          <b-form-input
            id="slave-id-input"
            v-model.number="formValues.slaveId"
            type="number"
            v-validate="'numeric'"
            :state="validateState('slave-id-input')"
            aria-describedby="slave-id-input-live-feedback"
            data-vv-name="slave-id-input"
            data-vv-as="Slave ID"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="slave-id-input-live-feedback">
            {{ veeErrors.first('slave-id-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group>
          <b-form-checkbox
            id="replace3to4-input"
            v-model="formValues.player.replace3To4"
          >
            Close bets on "ball in game" (player.replace3To4)
          </b-form-checkbox>
        </b-form-group>

        <b-form-group
          label="Max discrepancy time with nuke (player.maxDiff)"
          label-for="player-max-diff-id"
        >
          <b-form-input
            id="player-max-diff-input"
            v-model.number="formValues.player.maxDiff"
            type="number"
            v-validate="'numeric'"
            :state="validateState('player-max-diff-input')"
            aria-describedby="player-max-diff-input-live-feedback"
            data-vv-name="player-max-diff-input"
            data-vv-as="Time value"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="player-max-diff-input-live-feedback">
            {{ veeErrors.first('player-max-diff-input') }}
          </b-form-invalid-feedback>
        </b-form-group>

        <b-form-group label="Master Action URL" label-for="master-action-url">
          <b-form-input
            id="master-action-url-input"
            v-model="formValues.masterActionUrl"
            v-validate="{ required: false }"
            :state="validateState('master-action-url-input')"
            aria-describedby="master-action-url-input-live-feedback"
            data-vv-name="master-action-url-input"
            data-vv-as="masterActionURL"
            autocomplete="off"
          />
          <b-form-invalid-feedback id="master-action-url-input-live-feedback">
            {{ veeErrors.first('master-action-url-input') }}
          </b-form-invalid-feedback>
        </b-form-group>
      </form>

      <b-button class="mt-2 float-right" variant="primary" @click="handleSubmit"
        >Save</b-button
      >
    </b-modal>
  </span>
</template>

<script>
import { getRouteIcon, ROUTE_SOURCES } from '../../utils/routerIcons'
import Multiselect from 'vue-multiselect'
import VJsoneditor from 'v-jsoneditor/src/index'
import Vue from 'vue'

// const croupierInterfaceTypes = ['timer', 'timerbj', 'vip', 'croupier', 'croupierbj', 'croupier-baccarat', 'baccarat-casino', 'baccarat-studio', 'roulette-studio', 'roulette-casino'];

const croupierInterfaceTypes = [
  'baccarat-casino',
  'baccarat-studio',
  'roulette-casino',
  'roulette-studio',
  'roulette-vip',
  'black-jack',
  'endless-black-jack'
]

export default {
  data() {
    return {
      modalShow: false,
      formValues: this.getInitialValues(),
      playerEditorError: '',
      selectedTables: []
    }
  },
  components: {
    Multiselect,
    VJsoneditor
  },
  props: {
    create: Boolean,
    title: String,
    defaultValues: Object
  },
  methods: {
    handleActiveMod() {
      // Получаем текущие данные из JSON-редактора
      let playerData = this.$refs['player-editor']
        ? this.$refs['player-editor'].editor.get()
        : this.formValues.player || {}

      // Преобразуем строку в объект, если нужно
      if (typeof playerData === 'string') {
        try {
          playerData = JSON.parse(playerData)
        } catch (e) {
          playerData = {}
        }
      }

      if (!playerData) {
        playerData = {}
      }

      if (this.formValues.activeMod) {
        // Устанавливаем значения по умолчанию
        playerData.timeBeforeCloseOnWait = 1000000
        playerData.maxStateWait = 1000000
        playerData.croupierInterface = 'roulette-studio'
        playerData.isv2Studio = true
        playerData.isv2IgnoreNext5Mode = true
      } else {
        // Удаляем параметры активного мода
        delete playerData.timeBeforeCloseOnWait
        delete playerData.maxStateWait
        delete playerData.croupierInterface
        delete playerData.isv2Studio
        delete playerData.isv2IgnoreNext5Mode
      }

      // Обновляем JSON-редактор
      if (this.$refs['player-editor']) {
        this.$refs['player-editor'].editor.set(playerData)
      } else {
        this.formValues.player = playerData
      }
    },
    async onShow() {
      await this.$store.dispatch('gameTypes/loadList')
      this.setDefaults()
    },
    getInitialValues() {
      return {
        id: null,
        name: null,
        order: null,
        ip: null,
        port: null,
        timeout: null,
        proxy: null,
        proxyPort: null,
        activeMod: false,
        player: {
          playerType: 1,
          playerConfig: {},
          maxDiff: null,
          replace3To4: null,
          croupierInterface: null
        },
        tables: [],
        apiKey: null,
        slaveId: null,
        gameType: null
      }
    },
    setDefaults() {
      let initialValues = this.getInitialValues()

      for (let field in initialValues) {
        Vue.set(this.formValues, field, initialValues[field])
      }

      if (this.defaultValues) {
        for (let field in this.defaultValues) {
          Vue.set(this.formValues, field, this.defaultValues[field])
        }

        this.selectedTables = this.tablesOptions.filter(option =>
          this.defaultValues.tables.includes(option.value)
        )

        // Проверяем наличие параметров активного мода в player
        if (
          this.formValues.player &&
          this.formValues.player.croupierInterface === 'roulette-studio' &&
          this.formValues.player.isv2Studio === true &&
          this.formValues.player.isv2IgnoreNext5Mode === true &&
          this.formValues.player.timeBeforeCloseOnWait === 1000000 &&
          this.formValues.player.maxStateWait === 1000000
        ) {
          this.formValues.activeMod = true
        }
      }
    },
    validateState(ref) {
      if (
        this.veeFields[ref] &&
        (this.veeFields[ref].dirty || this.veeFields[ref].validated)
      ) {
        return !this.veeErrors.has(ref)
      }
      return null
    },
    resetModal() {
      this.setDefaults()
    },
    hideModal() {
      this.$refs['modal-container'].hide()
    },
    toggle() {
      this.modalShow = !this.modalShow
    },
    handleSubmit() {
      try {
        // Получаем актуальные данные из JSON-редактора и обновляем formValues.player
        let editorData = this.$refs['player-editor'].editor.get()
        if (typeof editorData === 'string') {
          try {
            this.formValues.player = JSON.parse(editorData)
          } catch (e) {
            this.playerEditorError = 'The Player must be a valid json string'
            return
          }
        } else {
          this.formValues.player = editorData
        }

        this.playerEditorError = ''
      } catch (e) {
        this.playerEditorError = 'The Player must be a valid json string'
        return
      }

      this.$validator.validateAll().then(result => {
        if (!result) {
          return
        }

        this.formValues.tables = this.selectedTables.map(option => option.value)

        // Проверяем, что player существует
        if (!this.formValues.player) {
          this.formValues.player = {}
        }

        // Записываем в консоль для проверки
        console.log(
          'Player parameters:',
          JSON.stringify(this.formValues.player)
        )

        // Создаем объект данных для отправки на сервер
        const requestData = {
          ...this.formValues,
          order: Number.parseInt(this.formValues.order) || 0,
          port: Number.parseInt(this.formValues.port) || 0,
          timeout: Number.parseInt(this.formValues.timeout) || 0,
          gameType: Number.parseInt(this.formValues.gameType) || 0,
          proxy: Number.parseInt(this.formValues.proxy) || 0
        }

        this.$http({
          url: this.create
            ? '/api/v1/sources'
            : '/api/v1/sources/' + this.formValues.id,
          method: this.create ? 'POST' : 'PUT',
          data: requestData,
          headers: {
            'Content-Type': 'application/json'
          }
        })
          .then(() => {
            setTimeout(() => {
              this.$emit('finish')
            }, 500)

            this.hideModal()
            this.$toastr.i('Success')
          })
          .catch(err => {
            this.$toastr.e(JSON.stringify(err.response.data.message))

            throw err
          })
      })
    }
  },
  computed: {
    gameTypeOptions() {
      return this.$store.getters['gameTypes/list'].map(({ id, name }) => {
        return { value: id, text: `${name} (${id})` }
      })
    },
    croupierInterfaceOptions() {
      let options = croupierInterfaceTypes.map(type => {
        return { value: type, text: type }
      })
      options.unshift({ value: null, text: 'N/A' })
      return options
    },
    tablesOptions() {
      return (this.$store.getters['tablesForSelect/list'] || [])
        .filter(table => !table.isVirtualTable)
        .map(table => {
          return {
            value: Number.parseInt(table.value),
            label: `${table.label} (${table.value})`
          }
        })
    },
    routeIcon: () => getRouteIcon(ROUTE_SOURCES)
  },
  mounted() {
    this.setDefaults()
  }
}
</script>
